import { Injectable } from '@angular/core';
import { ResourceService } from './resource.service';
import { IAccountingUnit } from '@monorepo/interfaces';

@Injectable({ providedIn: 'root' })
export class AccountingUnitService extends ResourceService<IAccountingUnit, IAccountingUnit, IAccountingUnit> {
    constructor() {
        super('accounting-units');
    }
}
